// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'normalize.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import vueSlider from 'vue-slider-component'
import VueResource from 'vue-resource'
import Multiselect from 'vue-multiselect'

import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import './directives/Opacity'
import './assets/css/fullPage.css'

import store from './store'

/* eslint-disable */
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
  if (t < 1)
    return c/2*t*t + b
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

var requestAnimFrame = (function(){
  return  window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function( callback ){ window.setTimeout(callback, 1000 / 60); };
})();

window.$scrollTo = (to, callback, duration = 600) => {
  function move(amount) {
    document.documentElement.scrollTop = amount;
    document.body.parentNode.scrollTop = amount;
    document.body.scrollTop = amount;
  }
  function position() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
  }
  var start = position(),
    change = to - start,
    currentTime = 0,
    increment = 20
  var animateScroll = function() {
    currentTime += increment
    var val = Math.easeInOutQuad(currentTime, start, change, duration)
    move(val)
    if (currentTime < duration)
      requestAnimFrame(animateScroll)
    else
      if (callback && typeof(callback) === 'function') callback()
  };
  animateScroll();
}

window.$loadImages = (imagesArray) => {
  for (let i = 0; i < imagesArray.length; i += 1) {
    const newImage = new Image()
    newImage.onload
    newImage.src = imagesArray[i]
  }
  return Promise.resolve()
}

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueResource)
Vue.component('v-slider', vueSlider)
Vue.component('v-multiselect', Multiselect)

/* eslint-disable no-new */

const initApp = (data) => {
  const _store = store(data)
  new Vue({
    el: '#app',
    store: _store,
    router: router(_store),
    template: '<App/>',
    components: { App },
  })
}

let param = /_=([^&]+)/.exec(location.search)

if (!(param && param[1]) && localStorage.userhash) {
  param = [0, localStorage.userhash]
}

if (param && param[1]) {
  localStorage.userhash = param[1]
  const data = atob(param[1]).split('.')
  Vue.http.get('/api/user/' + data[0] + '/' + data[1])
  .then(response => response.json())
  .then((respose) => {
    if (respose.success) {
      console.log(respose.data)
      initApp({
        userid: data[0],
        usercode: data[1],
        username: respose.data.name,
        ...respose.data.result
      })
    } else {
      initApp({});
    }    
  })
} else {
  initApp({})
}



// WEBPACK FOOTER //
// ./src/main.js